import OrderableModel from '@/models/OrderableModel';

export default class Category extends OrderableModel {
    get route () {
        return 'categories';
    }

    static get className () {
        return 'Category';
    }

    static get isInStore () {
        return true;
    }
}
